import { render, staticRenderFns } from "./bifen.vue?vue&type=template&id=16e1b5da&scoped=true&"
import script from "./bifen.vue?vue&type=script&lang=js&"
export * from "./bifen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e1b5da",
  null
  
)

export default component.exports